import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { ApiEndPointUrl } from '@fuse/utils/systemEnums';
import { CommonService } from '@fuse/services/common.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'environments/environment';


@Component({
  selector: 'auth-qr-dialog',
  templateUrl: './auth-qr-dialog.html',
  styleUrls: ['./auth-qr-dialog.scss']
})
export class AuthQrDialog implements OnInit {
  pin = ''

  constructor(
    private _fb: UntypedFormBuilder,
    public matDialogRef: MatDialogRef<AuthQrDialog>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _http: HttpClient,
    private _commonService: CommonService,
    private _matSnackBar: MatSnackBar,
    private _router: Router
  ) { }

  ngOnInit() {
    console.log('---> data here -->', this._data)
  }

  onSubmit() {
    console.log("----->", this.pin);
    this._http.post(environment.apiURL + 'admin/verify/authuser', { token: this.pin, setUpAuthy: +(!this._data.isAuthySetUp) }, this._commonService.getHeader())
      .subscribe(async (result: any) => {
        if (result.status == 200) {
          localStorage.removeItem('userToken');
          localStorage.setItem('isAuthySetUp', '1')
          localStorage.setItem('userToken', result.data.admin.token)
          this.matDialogRef.close()
          setTimeout(() => {
            this._router.navigate(['/home']);
          }, 200);
        } else {
          this._matSnackBar.open(result.message, 'OK', { duration: 2000 })
        }
      })
  }

}
